<template>
  <el-card>
    <el-row :gutter="0" style="margin-bottom: 10px">
      <el-col :span="4">
        <!-- 模板选择 -->
        <el-select v-model='mode' showSearch @change="changeMode" :defaultValue="0" option-label-prop="label"
                  style="width: 100%;">
          <el-option v-for='(opt,idx) in modeList' :key='idx' :label="opt.name" :value='idx'>
            {{ opt.name }}
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="20">
        <el-row>
          <el-row>
            <!-- 纸张设置 -->
            <el-button-group>
              <template v-for="(value,type) in paperTypes">
                <el-button :type="curPaperType === type ? 'primary' : 'info'" @click="setPaper(type,value)" :key="type">
                  {{ type }}
                </el-button>
              </template>
              <el-popover v-model="paperPopVisible" title="设置纸张宽高(mm)" trigger="click">
                <div slot="content">
                  <el-input-group compact style="margin: 10px 10px">
                    <el-input type="number" v-model="paperWidth" style=" width: 100px; text-align: center"
                             placeholder="宽(mm)"/>
                    <el-input style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                             placeholder="~" disabled
                    />
                    <el-input type="number" v-model="paperHeight"
                             style="width: 100px; text-align: center; border-left: 0"
                             placeholder="高(mm)"/>
                  </el-input-group>
                  <el-button type="primary" style="width: 100%" @click="otherPaper">确定</el-button>
                </div>
                <el-button :type="'other'==curPaperType?'primary':''">自定义纸张</el-button>
              </el-popover>
            </el-button-group>
            <el-button type="text" icon="zoom-out" @click="changeScale(false)"></el-button>
            <el-input-number
              :value="scaleValue"
              :min="scaleMin"
              :max="scaleMax"
              :step="0.1"
              disabled
              style="width: 70px;"
              :formatter="value => `${(value * 100).toFixed(0)}%`"
              :parser="value => value.replace('%', '')"
            />

            <!-- <el-form-item label="Rebate比率:"  > 
              <el-input-number   :precision="3" size="mini" 
                  v-model="rebate_rate"  controls-position="right" id="rebateInput">
                </el-input-number>
              </el-form-item> -->

            <el-button type="text" icon="zoom-in" @click="changeScale(true)"></el-button>
            <!-- 预览/打印 -->
            <el-button-group>
              <el-button type="primary" icon="eye" @click="preView">
                预览
              </el-button>
              <el-button type="primary" @click="print">
                直接打印
                <el-icon type="printer"/>
              </el-button>
            </el-button-group>
            <!-- 保存/清空 -->
            <el-button-group>
              <el-button type="primary" icon="save" @click="save">
                保存
              </el-button>
              <el-popconfirm
                title="是否确认清空?"
                okType="danger"
                okText="确定清空"
                @confirm="clearPaper"
              >
                <el-icon slot="icon" type="question-circle-o" style="color: red"/>
                <el-button type="danger">
                  清空
                  <el-icon type="close"/>
                </el-button>
              </el-popconfirm>
            </el-button-group>
            <json-view :template="template"/>
          </el-row>
          <!-- 多面板的容器 -->
          <div class="hiprint-printPagination" style="margin-top: 14px;"></div>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="0">
      <el-col :span="4">
        <el-card style="height: 100vh">
          <el-row>
            <el-col :span="24" class="rect-printElement-types hiprintEpContainer">
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="14">
        <el-card class="card-design">
          <div id="hiprint-printTemplate" class="hiprint-printTemplate"></div>
        </el-card>
      </el-col>
      <el-col :span="6" class="params_setting_container">
        <el-card>
          <el-row class="hinnn-layout-sider">
            <div id="PrintElementOptionSetting"></div>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- 预览 -->
    <print-preview ref="preView"/>
  </el-card>
</template>

<script>

import printPreview from './preview'
import jsonView from '../json-view.vue'

import {hiprint} from '@/index'
import {providers, providerList} from './providers'
import printData from './print-data'

let hiprintTemplate;
export default {
  name: "printPanels",
  components: {printPreview, jsonView},
  data() {
    return {
      template: null,
      // 模板选择
      mode: 0,
      modeList: [],
      // 当前纸张
      curPaper: {
        type: 'other',
        width: 220,
        height: 80
      },
      // 纸张类型
      paperTypes: {
        'A3': {
          width: 420,
          height: 296.6
        },
        'A4': {
          width: 210,
          height: 296.6
        },
        'A5': {
          width: 210,
          height: 147.6
        },
        'B3': {
          width: 500,
          height: 352.6
        },
        'B4': {
          width: 250,
          height: 352.6
        },
        'B5': {
          width: 250,
          height: 175.6
        }
      },
      scaleValue: 1,
      scaleMax: 5,
      scaleMin: 0.5,
      // 自定义纸张
      paperPopVisible: false,
      paperWidth: '220',
      paperHeight: '80',
      lastjson: '',
    }
  },
  computed: {
    curPaperType() {
      let type = 'other'
      let types = this.paperTypes
      for (const key in types) {
        let item = types[key]
        let {width, height} = this.curPaper
        if (item.width === width && item.height === height) {
          type = key
        }
      }
      return type
    }
  },
  mounted() {
    this.init()
    this.otherPaper()
  },
  methods: {
    init() {
      this.modeList = providerList
      this.changeMode()
      this.buildTemplate()
    },
    changeMode() {
      let {mode} = this
      let provider = providerList[mode]
      hiprint.init({
        providers: [...providers]
      });
      $('.hiprintEpContainer').empty()
      hiprint.PrintElementTypeManager.build('.hiprintEpContainer', provider.value);

    },
    buildTemplate() {
      $('#hiprint-printTemplate').empty()
      let templates = this.$ls.get('KEY_TEMPLATES_PANELS', {})
      let that = this;
      this.template = hiprintTemplate = new hiprint.PrintTemplate({
        template: templates,
        settingContainer: '#PrintElementOptionSetting',
        paginationContainer: '.hiprint-printPagination',
        defaultPanelName: '默认面板名称',
        onPanelAddClick: (panel, createPanel) => {
          panel.name = '新面板' + (panel.index + 1);
          that.$message.success('弹出个东西,让你们知道,在这里可以自定义面板名称');
          that.$notification.success({
            placement: 'topRight',
            message: '弹出个东西,让你们知道,在这里可以自定义面板名称',
            description: '自定义面板名称',
          });
          createPanel(panel);
        },
      });
      hiprintTemplate.design('#hiprint-printTemplate', {grid: true});
      // 获取当前放大比例, 当zoom时传true 才会有
      this.scaleValue = hiprintTemplate.editingPanel.scale || 1;
    },
    /**
     * 设置纸张大小
     * @param type [A3, A4, A5, B3, B4, B5, other]
     * @param value {width,height} mm
     */
    setPaper(type, value) {
      try {
        if (Object.keys(this.paperTypes).includes(type)) {
          this.curPaper = {type: type, width: value.width, height: value.height}
          hiprintTemplate.setPaper(value.width, value.height)
        } else {
          this.curPaper = {type: 'other', width: value.width, height: value.height}
          hiprintTemplate.setPaper(value.width, value.height)
        }
      } catch (error) {
        this.$message.error(`操作失败: ${error}`)
      }
    },
    changeScale(big) {
      let scaleValue = this.scaleValue;
      if (big) {
        scaleValue += 0.1;
        if (scaleValue > this.scaleMax) scaleValue = 5;
      } else {
        scaleValue -= 0.1;
        if (scaleValue < this.scaleMin) scaleValue = 0.5;
      }
      if (hiprintTemplate) {
        // scaleValue: 放大缩小值, false: 不保存(不传也一样), 如果传 true, 打印时也会放大
        hiprintTemplate.zoom(scaleValue, true);
        this.scaleValue = scaleValue;
      }
    },
    otherPaper() {
      let value = {}
      value.width = this.paperWidth
      value.height = this.paperHeight
      this.paperPopVisible = false
      this.setPaper('other', value)
    },
    preView() {
      let {width} = this.curPaper
      this.$refs.preView.show(hiprintTemplate, printData, width)
    },
    print() {
      if (window.hiwebSocket.opened) {
        const printerList = hiprintTemplate.getPrinterList();
        console.log(printerList)
        hiprintTemplate.print2(printData, {printer: '', title: 'hiprint测试打印'});
        return
      }
      this.$message.error('客户端未连接,无法直接打印')
    },
    save() {
      let json = hiprintTemplate.getJson();
      console.log(json);
      this.$ls.set('KEY_TEMPLATES_PANELS', json)
      this.$message.info('保存成功')
    },
    clearPaper() {
      try {
        hiprintTemplate.clear();
      } catch (error) {
        this.$message.error(`操作失败: ${error}`);
      }
    }
  }
}
</script>

<style lang="less" scoped>
// build 拖拽
/deep/ .hiprint-printElement-type > li > ul > li > a {
  padding: 4px 4px;
  color: #1296db;
  line-height: 1;
  height: auto;
  text-overflow: ellipsis;
}

// 默认图片
/deep/ .hiprint-printElement-image-content {
  img {
    content: url("~@/assets/logo.png");
  }
}

// 设计容器
.card-design {
  overflow: hidden;
  overflow-x: auto;
  overflow-y: auto;
}

</style>
